import { Box, Icons, Text, ThemeContext } from '@vouched.id/vault';
import React, { useContext, useState } from 'react';
import { UpArrow } from '../Icons/UpArrow';
import { dropdownWrapperStyle } from './utils';
export const Dropdown = ({ children, title, statusIcon }) => {
    const shadow = useContext(ThemeContext).theme.tokens.shadows.hover;
    const [open, setOpen] = useState(false);
    return (React.createElement(Box, { style: dropdownWrapperStyle },
        React.createElement(Box, { backgroundColor: "colors.white", display: "flex", marginBottom: "spacing.default", onClick: () => {
                setOpen((v) => !v);
            }, padding: "spacing.default", style: {
                borderRadius: '10px',
                justifyContent: 'space-between',
                alignItems: 'center',
                boxShadow: shadow,
                cursor: 'pointer'
            } },
            React.createElement(Text, null, title),
            React.createElement(Box, { display: "flex", style: {
                    alignItems: 'center'
                } },
                statusIcon,
                open ? React.createElement(UpArrow, null) : React.createElement(Icons.DownArrow, null))),
        open && React.createElement(Box, { margin: "spacing.default" }, children)));
};
